<template>
  <div class="container">
    <homeHeader title="报告审批"></homeHeader>
    <div class="main">
      <div class="card">
        <!-- 按钮组 -->
        <div class="toolbar-dv">
          <toolBarBtn
            @changeSearchFormShow="changeSearchFormShow"
            :buttonVisible="buttonVisible"
            :moreButtonList="moreButtonList"
            :parentData="this"
            ref="toolBarBtn"
          ></toolBarBtn>
        </div>
        <!-- 查找面板 -->
        <div class="search-dv" v-show="searchFormVisible">
          <SearchForm
            ref="SearchForm"
            v-show="searchFormVisible"
            :searchVuePath="searchVuePath"
            :menuArgs="''"
            @search="sureSearch"
          ></SearchForm>
        </div>
        <!-- 主表信息 -->
        <div class="approve-table-dv">
          <!-- 菜单明细 -->
          <div class="menu-dv" :style="{ height: this.approveCardHeight }">
            <div class="table-dv">
              <vxe-grid
                ref="xTable"
                resizable
                :column-config="{ minWidth: '80px' }"
                :data="tableData"
                :showOverflow="true"
                size="mini"
                :mouse-config="{ area: true }"
                :tooltip-config="{
                  showAll: true,
                  theme: 'dark'
                }"
                :pager-config="tablePage"
                @page-change="handlePageChange"
                :seq-config="{
                  startIndex: (tablePage.currentPage - 1) * tablePage.pageSize
                }"
                highlight-hover-row
                highlight-current-row
                :height="tableHeight"
                :columns="gridColumnsMenu"
                @cell-dblclick="handleDblclick"
                :keyboard-config="{
                  isArrow: true,
                  isEnter: true,
                  isTab: true,
                  isClip: true,
                  enterToTab: true,
                  isEdit: true
                }"
                :scroll-y="{
                  mode: 'wheel'
                }"
                :cell-style="cellStyle"
              >
              </vxe-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DetailModal ref="DetailModalRef" @updateData="refresh" />
  </div>
</template>

<script>
import DetailModal from './DetailModal.vue'
import { getState, getApprover } from '../../utils/state'
import { getSuccessStateByRow } from '../../utils/state'

export default {
  name: 'ReportApprove',
  components: {
    DetailModal
  },
  data() {
    return {
      id: 0,
      // 是否显示查询
      searchFormVisible: false,
      // 查询条件
      searchObjects: [],
      gridColumnsMenu: [],
      // 查询条件vuepath
      searchVuePath: 'ReportApprove',
      // 正常状态下，需要加上表格距离card上下的margin
      topBottomMargin: 20,
      // 按钮组的可见性
      buttonVisible: {
        add: true, // 新增按钮是否显示
        update: false, // 修改按钮
        save: false, // 保存按钮是否显示
        delete: false, // 删除按钮是否显示
        refresh: true, // 刷新数据按钮是否显示
        lock: false, // 锁定按钮是否显示
        unlock: false, // 解锁按钮是否显示
        sort: false, // 排序按钮是否显示
        search: true, // 查找按钮是否显示
        more: false // 更多按钮是否显示
      },
      // form: {
      // },
      // detailListBRoleEmployee: [],
      tableData: [],
      // 模态窗类型
      modalType: '',
      // 模态窗id,用于修改单据
      modalId: 0,
      // 分页设置
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: this.tablePageConfig.defaultPageSize,
        align: 'right',
        pageSizes: this.tablePageConfig.pageSizes,
        layouts: ['Sizes', 'PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'FullJump', 'Total'],
        perfect: true
      },
      // 右键缓存
      areas: {},
      colProperty: '',
      // 拓展按钮
      moreButtonList: [],
      // 获取权限
      Authority: this.AuthorityFilter(this.$route.path),
      // table快捷键
      bodyMenus: [[]]
    }
  },
  mounted() {},
  activated() {
    this.list()
  },
  created() {
    this.InitColumn()
    this.moreButtonList = [
      // {
      //   name: '清空筛选',
      //   icon: 'el-icon-brush',
      //   visible: true,
      //   event: 'handleClearFilter'
      // }
    ]
  },
  methods: {
    // 单元格右键被点击事件
    async cellContextMenuEvent({ $table }) {
      const that = this
      const a = $table.getCellAreas()
      if (a) {
        const total = that.tableSelectTotal(a)
        that.bodyMenus[0][0].children = []
        that.bodyMenus[0][0].children.push({ code: 'total', name: total })
      }
    },
    // 清空筛选
    handleClearFilter() {
      this.$refs.xTable.clearFilter()
    },
    // 查找
    search() {
      this.searchFormVisible = !this.searchFormVisible
    },
    // 确认查找
    sureSearch(searchObjects) {
      const that = this
      that.searchObjects = searchObjects
      that.tablePage.currentPage = 1
      that.list()
    },
    // 页面函数
    handlePageChange({ currentPage, pageSize }) {
      const that = this
      that.tablePage.currentPage = currentPage
      that.tablePage.pageSize = pageSize
      that.list()
    },
    // 初始化
    InitColumn() {
      this.gridColumnsMenu = [
        { type: 'seq', width: 40, fixed: 'left' },
        {
          field: 'document_status',
          title: '状态',
          width: '120px',
          slots: {
            default: ({ row }) => {
              return [<span>{getState(row, 'ReportApprove')}</span>]
            }
          }
        },
        {
          field: 'approver',
          title: '已审批人',
          width: '140px',
          slots: {
            default: ({ row }) => {
              return [<span>{getApprover(row, 'ReportApprove')}</span>]
            }
          }
        },

        {
          field: 'num',
          title: '报告编号',
          width: '150px',
          sortable: true,
          sortType: 'string'
        },
        {
          field: 'client',
          title: '委托单位'
        },
        {
          field: 'company',
          title: '公司'
        },
        {
          field: 'users_name',
          title: '申请人',
          width: '100px'
        },
        {
          field: 'apply_date',
          title: '申请日期',
          formatter: ['formatDate', 'yyyy-MM-dd'],
          width: '100px',
          sortable: true,
          sortType: 'string'
        },
        {
          field: 'is_stamped',
          title: '是否盖章'
        },
        {
          field: 'is_mailed',
          title: '是否邮寄'
        },
        {
          field: 'is_payment_arrived',
          title: '是否到款'
        },

        {
          field: 'memo',
          title: '说明'
        },

        {
          field: 'approve_opinions',
          title: '领导审批意见',
          minWidth: '150px'
        },
        {
          field: 'last_modify_time',
          title: '最后更新时间',
          formatter: ['formatDate', 'yyyy-MM-dd HH:mm:ss'],
          width: '140px'
        }
      ]
    },
    // 切换查询面板可见性
    changeSearchFormShow() {
      this.searchFormVisible = !this.searchFormVisible
    },
    // 双击数据
    handleDblclick({ row }) {
      this.$refs.DetailModalRef.openModal(row.id)
    },
    // 新增
    async add() {
      this.$refs.DetailModalRef.openModal()
    },
    // 修改按钮
    async update() {
      if (this.id === 0) {
        this.$message.error('您暂未选中单据，请选择后重试')
        return
      }
      this.modalType = '修改'
      this.modalId = this.id
      this.$refs.AddOrSeeRequireModal.formVisible = true
    },
    // 刷新数据
    refresh() {
      if (!this.Authority.see) {
        this.$message.error('您没有相关权限！')
        return
      }
      this.list()
    },
    // 获取数据
    async list() {
      const { data: res } = await this.$http.post('/Finance/Report_approve/list', {
        pageIndex: this.tablePage.currentPage,
        pageSize: this.tablePage.pageSize,
        seeType: this.Authority.seeType,
        searchObjects: this.searchObjects
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.tableData = res.data.rows
      this.tablePage.total = res.data.totals
    },
    // 点击导出
    async exp() {
      const that = this
      that.$refs.xTable.exportData({
        filename: '报告审批单',
        sheetName: 'Sheet1',
        type: 'xlsx',
        columnFilterMethod({ column }) {
          return column.property !== undefined
        }
      })
    },
    // 样式
    cellStyle({ row }) {
      // 不通过
      if (row.document_status < 0) {
        return {
          backgroundColor: '#f56c6c',
          color: '#ffffff'
        }
      }

      const successStyle = {
        backgroundColor: '#2ed573'
      }

      // 财务已处理自己的数据
      if (getSuccessStateByRow(row)) {
        return successStyle
      }
    }
  },
  computed: {
    tableHeight() {
      let isSearchForm = this.searchFormVisible
      let isToolBar = true

      // 若有查询框，则共有四段 margin; 否则只有表格的两段 margin
      let tableMargin = isSearchForm ? this.heightConfig.mainMargin * 4 : this.heightConfig.mainMargin * 2
      return this.tableHeightComputed(tableMargin + this.topBottomMargin, isSearchForm, isToolBar)
    },
    // 表格容器高度，需加上margin边距
    approveCardHeight() {
      return this.tableHeight + this.topBottomMargin
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  margin: 0 auto;
  height: calc(100vh - @header-height);
  overflow: hidden;
}
.card {
  margin: @main-margin;
  box-shadow: #bebebe 2px 2px 10px;
  border-radius: 10px;
  overflow: hidden;
}
.search-dv {
  background-color: aquamarine;
  height: 110px;
  margin: @main-margin 10px;
}

.toolbar-dv {
  padding: 10px;
}

.table-dv {
  padding: @topBottomMargin;
}

.approve-table-dv {
  display: flex;
  // 行高度，需要比 row-config 的 height 多20px，可以让内容与单元格之间有内边距
  // /deep/ .vxe-body--row {
  //   height: 80px !important;
  // }
}
// 角色名称列表
.left-role-dv {
  width: 15%;
  padding: 10px;
}
.role-list-dv {
  width: 100%;
  border-radius: 5px;
  box-shadow: #e2e2e2 0px 0px 3px;
  border: 1px solid #eeeeee;
  overflow: hidden;
  position: relative;
}

// 用户名列表
.middle-user-dv {
  width: 35%;
}
// 权限菜单列表
.menu-dv {
  width: 100%;
}

.vxe-checkbox {
  width: 15px !important;
}
</style>
